import React from 'react';
import PropTypes from 'prop-types';
import CategoryRow from './CategoryRow';
import FeaturedCollectionsRow from './FeaturedCollectionsRow';

const Categories = props => {
  const {
    categories = [],
    fptiClick,
    fptiImpression,
    toolTileProps,
    viewAllText,
    showAllText
  } = props;
  const {
    flatPSData: {
      collections,
      main: [{ featuredCollectionsTitle }] = [{}]
    } = {},
    experimentation: { coloredIconsExp: isColoredIconsEligible } = {}
  } = toolTileProps;

  return (
    <>
      <div id="appcenter-categories">
        {categories.map(
          ({ content = {}, featured = [] }, index) =>
            index < 2 && (
              <CategoryRow
                key={`appcenter-categories-${index}`}
                content={content}
                featured={featured.slice(0, 3)}
                viewAllText={viewAllText}
                showAllText={showAllText}
                fptiClick={fptiClick}
                fptiImpression={fptiImpression}
                toolTileProps={toolTileProps}
                isColoredIconsEligible={isColoredIconsEligible}
              />
            )
        )}
      </div>
      <div id="appcenter-categories" className="mobile-bkg fitted">
        <FeaturedCollectionsRow
          collections={collections}
          fptiClick={fptiClick}
          fptiImpression={fptiImpression}
          featuredCollectionsTitle={featuredCollectionsTitle}
        />
      </div>
      <div id="appcenter-categories">
        {categories.map(({ content = {}, featured = [] }, index) => (
          <>
            {index >= 2 && (
              <CategoryRow
                key={`appcenter-categories-${index}`}
                content={content}
                featured={index > 1 ? featured.slice(0, 3) : featured}
                viewAllText={viewAllText}
                showAllText={showAllText}
                fptiClick={fptiClick}
                fptiImpression={fptiImpression}
                toolTileProps={toolTileProps}
                isColoredIconsEligible={isColoredIconsEligible}
              />
            )}
          </>
        ))}
      </div>
    </>
  );
};

Categories.propTypes = {
  fptiClick: PropTypes.func,
  fptiImpression: PropTypes.func,
  categories: PropTypes.array,
  toolTileProps: PropTypes.object,
  viewAllText: PropTypes.string,
  isColoredIconsEligible: PropTypes.bool,
  showAllText: PropTypes.string
};

export default Categories;
